/**
 * Archive CD Bio Scripts
 *
 * @package    cd_bio
 * @author     Chatman Design / Dustin Paluch <dustin@chatmandesign.com>
 * @link       https://chatmandesign.com
 * @copyright  2017 Chatman Design
 */

$(document).ready(function() {

	// FIXME: Gulp shouldn't consume everything in the scripts folder.
	if ($("body").hasClass("post-type-archive-cd_bio")) {
		$(".bio-modal-trigger").modaal({
			custom_class: "bio-modal-wrapper",
		});
	}
});
